import React, { useState, useEffect, useRef } from "react";
import { ScrollTop } from "primereact/scrolltop";
import { useHistory } from "react-router-dom";
import { Toast } from "primereact/toast";
import TranslationFile from "../15-Translation/locale/Translation_apps.json";
import "./ScrollTop.css";

let cartValuesLocalData;
let mappingCartArray = [];
let currentUser = localStorage.getItem("rebelSkoolUser");
let cartDisable = "";
let userSelectedLanguage = localStorage.getItem("selectedLanguage");
let currentUrl = window.location.href;
if (currentUser) {
  currentUser = JSON.parse(localStorage.getItem("rebelSkoolUser"));
}

export default function ScrolltoTop(props) {
  const history = useHistory();
  const toast = useRef(null);

  const [cartCount, setCartCount] = useState(0);
  const [loginToastShowing, setLoginToastShowing] = useState(false);

  useEffect(() => {
    loadCartValue();
  }, []);

  const loadCartValue = () => {
    let filteredPeople = [];

    if (currentUser && localStorage.getItem("cartValues") != "") {
      currentUser = JSON.parse(localStorage.getItem("rebelSkoolUser"));

      cartValuesLocalData =
        JSON.parse(localStorage.getItem("cartValues")) || [];

      filteredPeople =
        currentUser != undefined &&
        cartValuesLocalData.filter((item) => item.userID == currentUser.userID);

      setCartCount(
        filteredPeople.length != 0 ? filteredPeople[0].cartArray.length : []
      );
    }
  };

  const cartOnClick = () => {
    loadCartValue();
    if (currentUser == null) {
      if (!loginToastShowing) {
        toast.current.show({
          severity: "warn",
          summary:
            TranslationFile.cartLoginRequestSummary[userSelectedLanguage],
          detail: TranslationFile.cartLoginRequestDetails[userSelectedLanguage],
          life: 3000
        });

        setLoginToastShowing(true);

        setTimeout(() => {
          setLoginToastShowing(false);
        }, 3000);
      }
    } else if (cartCount == 0) {
      toast.current.show({
        severity: "warn",
        summary: TranslationFile.cartEmptySummary[userSelectedLanguage],
        detail: TranslationFile.cartEmptyDetails[userSelectedLanguage],
        life: 3000
      });

      setLoginToastShowing(true);

      setTimeout(() => {
        setLoginToastShowing(false);
      }, 3000);
    } else {
      let lsSessionUUID = localStorage.getItem("sessionUUID");

      let currentUrl = window.location.href;
      let splitUtlBySlashLength = currentUrl.split("/").length;

      if (splitUtlBySlashLength == 4) {
        history.push("annualreport/" + lsSessionUUID + "/payment");
      } else if (splitUtlBySlashLength == 6) {
        history.push("payment");
      }
    }
  };
  //if current url start with /income-declaration 2 then hide the cart icon
  if (currentUrl.includes("/income-declaration-2")) {
    cartDisable = "none";
  }
  return (
    <div style={{ position: "relative", zIndex: 0 }}>
      <Toast ref={toast} />
      <div style={{ display: cartDisable }} className="right-bottom-cart">
        <i
          style={{ display: cartDisable }}
          className="pi pi-cart-plus"
          id="cart"
          onClick={() => cartOnClick()}
        />

        <div
          style={{ display: cartDisable }}
          className="cart-wrapper"
          onClick={cartOnClick}
        >
          <i
            style={{ display: cartDisable }}
            className="pi pi-cart-plus cart-icon"
          />
          <span className="cart-badge" style={{ display: cartDisable }}>
            {props.count == 0 || props.count == undefined
              ? cartCount
              : props.count}
          </span>
        </div>
      </div>

      <ScrollTop
        threshold={100}
        className="w-2rem h-2rem border-round bg-primary scrolltop-custom"
        icon="pi pi-arrow-up text-base"
      />
    </div>
  );
}
